import { Component, Input, TemplateRef } from '@angular/core'
import { RootState } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { distinctUntilChanged } from 'rxjs/operators'
import { getIsAccountSelectedOrLoadedOrJobFocused } from '../content-predicate-streams'

@Component({
  selector: 'hs-no-loaded-or-focused-account',
  styleUrls: ['no-loaded-or-focused-account.component.scss'],
  templateUrl: 'no-loaded-or-focused-account.component.html',
})
export class NoLoadedOrFocusedAccountComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() content: TemplateRef<any> | null = null

  isAccountSelected = getIsAccountSelectedOrLoadedOrJobFocused(this.store).pipe(
    distinctUntilChanged(),
  )

  constructor(private readonly store: Store<RootState>) {}
}
